import React from 'react';
import { DisabledTag } from '@nile/components';
import { FormattedMessage } from 'react-intl';

function TextCell(props) {
  const { cell } = props;
  let displayValue = '';
  switch (cell.column.id) {
    case 'role':
    case 'sop':
    case 'sla':
    case 'client':
      displayValue = cell.value?.name;
      break;
    default:
      displayValue = cell.value;
  }
  return (
    <div>
      {displayValue || (
        <DisabledTag>
          <FormattedMessage id="app.noData.message" />
        </DisabledTag>
      )}
    </div>
  );
}

export default TextCell;
